export default "__VITE_ASSET__IDhOJFlb__"